var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationCircle = function SvgExclamationCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 4,
    stroke: "#F55060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    transform: "rotate(-180 6 6)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F55060",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M5.995 7.773H6v.005h-.005z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F55060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M5.995 5.995V4.217"
  })));
};
export default SvgExclamationCircle;